import React, { useEffect, useRef } from "react";
import { getRpaTransportUrl } from "./RpaUrlHelper";
import moment from "moment";

/** @typedef {import('../controllers/RpaController.js').FilterObj } FilterObj */

/**
 * @typedef {object} RpaPlanningHeaderSearchParams
 * @property {'front'|'back'} view - Vue actuelle (front ou back)
 * @property {FilterObj} filter - Filtres appliqués
 * @property {function(string, object):void} onDateChange - Fonction de changement de date
 * @property {boolean} transportAndParkingOption - Indicateur du mode premium
 * @property {?string} [returnUrl] - URL de retour dans le planning si on vient d'une autre page
 */

/**
 * @param {RpaPlanningHeaderSearchParams} props
 */
export default function RpaPlanningHeaderSearch({ view, filter, onDateChange, transportAndParkingOption, returnUrl = null }) {
  var inputRef = useRef(),
    datePickerRef = useRef(),
    onDateChangeRef = useRef(onDateChange);

  useEffect(() => {
    /**
     * @param {any} event
     */
    var handleChangeDate = event => {
      onDateChangeRef.current(moment(event.detail.date).format("DD/MM/YYYY"), inputRef);
    };

    if (inputRef.current) {
      if (datePickerRef.current) {
        /** @type {any} */ (datePickerRef.current).destroy();
      }

      var options = {
        language: "fr",
        autohide: true,
        clearBtn: true,
        todayBtn: true,
        todayHighlight: true,
        todayBtnMode: 1,
        format: "dd/mm/yyyy"
      };

      // @ts-ignore
      /** @type {any}*/ (datePickerRef.current) = new Datepicker(inputRef.current, options);
      /** @type {HTMLInputElement}*/ (inputRef.current).value = filter.dayDateStr;
      /** @type {any}*/ (datePickerRef.current).setDate(filter.dayDateStr);
      /** @type {HTMLInputElement}*/ (inputRef.current).addEventListener("changeDate", handleChangeDate);
    }

    return () => {
      if (inputRef.current) {
        /** @type {HTMLInputElement}*/ (inputRef.current).removeEventListener("changeDate", handleChangeDate);
      }
    };
  }, [filter.dayDate, inputRef.current]);

  useEffect(() => {
    onDateChangeRef.current = onDateChange;
  }, [onDateChange]);

  return (
    <div className="resaplan__search resaplan__search--horizontal">
      <div className="flexline flexline--margin flexline--spaced flexline--align-vz no-mobile">
        {returnUrl ? (
          <a href={returnUrl} className="btn btn--small btn--no-label">
            <span className="material-icons">chevron_left</span>
            Retour
          </a>
        ) : (
          ""
        )}
        {view === "back" ? <h5 className="title title--center title--uppercase title--main-color">{filter.dateTitle}</h5> : ""}
      </div>
      <div className="flexline flexline--margin flexline--align-vz no-mobile">
        {view === "back" && transportAndParkingOption ? (
          <a href={getRpaTransportUrl(filter.dayDateStr)} data-tooltip="Récapitulatif des transports" className="btn btn--main-color btn--full">
            Transports
          </a>
        ) : (
          ""
        )}
        <div className="input-group input-group--no-margin">
          <input
            className="input-group__input"
            // @ts-ignore
            ref={inputRef}
            style={{ minWidth: "120px" }}
            aria-label="Date"
          />
        </div>
        <button data-loader="true" onClick={() => onDateChange(moment(filter.dayDate).subtract(1, "day").format("DD/M/YYYY"), inputRef)} className="btn btn--small btn--no-label">
          <span className="material-icons">chevron_left</span>
        </button>
        <button data-loader="true" className="btn" onClick={() => onDateChange(moment().format("DD/M/YYYY"), inputRef)}>
          Aujourd'hui
        </button>
        <button data-loader="true" onClick={() => onDateChange(moment(filter.dayDate).add(1, "day").format("DD/M/YYYY"), inputRef)} className="btn btn--small btn--no-label">
          <span className="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
  );
}
